import { render } from "./BasicPage.vue?vue&type=template&id=7172740b&scoped=true&ts=true"
import script from "./BasicPage.vue?vue&type=script&lang=ts"
export * from "./BasicPage.vue?vue&type=script&lang=ts"

import "./BasicPage.vue?vue&type=style&index=0&id=7172740b&scoped=true&lang=scss"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7172740b"]])

export default __exports__